import { CellContext } from '@tanstack/react-table';
import RegistrationDetailsCell from '@/features/dashboard/tours/components/RegistrationDetailsCell.tsx';
import { RegistrationDetailDto } from '@/features/dashboard/tours/types/RegistrationDetailsDto.ts';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';

export const registrationDetailsFieldRender = <T,>(
  info: CellContext<T, unknown>,
) => {
  const value = info.getValue() as RegistrationDetailDto | null | undefined;
  // `RegistrationDetailsCell` destrukturyzuje dto od razu, więc brak wartości
  // musi zostać odcięty tutaj.
  if (!value) return <EmptyValue />;

  return <RegistrationDetailsCell dto={value} />;
};
